import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirmar-cancelamento',
    templateUrl: './confirmar-cancelamento.component.html',
    styleUrls: ['./confirmar-cancelamento.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ConfirmarCancelamentoComponent {

  @Input() confirmarCancelamento: boolean = false;
  @Output() confirmarCancelamentoFechou = new EventEmitter();

  constructor() { }

  fecharAlertConfirmacao(acao: string) { this.confirmarCancelamentoFechou.emit(acao); }

}
